export default (): DropdownComponent => ({
    isOpen: false,
    init() {
      if(this.$refs.dropdown.offsetLeft != 0)
        document.documentElement.style.setProperty(
            "--flag-pos",
            this.$refs.dropdown.offsetLeft + 5 + "px"
        );
    },
});

import { AlpineComponent } from "alpinejs";

type DropdownComponent = AlpineComponent<{
    isOpen: boolean
}>;
